var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.204 10.796 19 9c.545-.545.818-.818.963-1.112a2 2 0 0 0 0-1.776C19.818 5.818 19.545 5.545 19 5c-.546-.545-.818-.818-1.112-.963a2 2 0 0 0-1.776 0c-.294.145-.567.418-1.112.963l-1.82 1.82a10.9 10.9 0 0 0 4.023 3.977Zm-5.477-2.523-6.87 6.87c-.426.426-.638.638-.778.9-.14.26-.199.555-.317 1.145l-.615 3.077c-.067.332-.1.499-.005.593.094.095.26.062.593-.005l3.077-.615c.59-.118.884-.177 1.145-.317.262-.14.474-.352.9-.777l6.889-6.89a12.901 12.901 0 0 1-4.02-3.98Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlackIcon);
export default __webpack_public_path__ + "static/media/edit-black-icon.c733884ba5398b076a265859737a9d64.svg";
export { ForwardRef as ReactComponent };